import { getDefaultStore } from 'jotai';
import { coreEntityMissingDialogAtom } from '../store/coreEntityMissingStore';

export interface CoreEntityMissingResponse {
  coreEntityMissing: true;
  title: string;
  message: string;
}

export const coreEntityMissingHandler = (data: CoreEntityMissingResponse) => {
  const store = getDefaultStore();
  store.set(coreEntityMissingDialogAtom, {
    open: true,
    title: data.title,
    message: data.message,
    contextUrl: window.location.pathname,
  });
};
